// One meeting, wherever it appears. The month cell, the day and week columns and the list
// all render this, so a meeting looks the same everywhere and there is one place that
// decides what a meeting is CALLED.
//
// WHAT IT IS CALLED, in order: its own title if it has one, otherwise the client's name,
// otherwise "פגישה פנימית" — and an external meeting by the person's name first. The
// title is optional on purpose — for a client meeting the client's name is the useful
// label, and demanding a title would only add a field to fill.
import he from '../../i18n/he';
import { chipStyle } from './meetingColors';
import { isCancelled, isExternal, isHeld, isInternal } from './meetingKind';

export const meetingLabel = (m) => {
  // An external meeting (077) is called by the person met, before its title: there is no
  // client name to fall back on, and the name is what the owners look for.
  if (isExternal(m)) return m.title ? `${m.external_name} · ${m.title}` : m.external_name;
  if (m.title) return m.title;
  if (isInternal(m)) return he.calendar.internalLabel;
  return m.client_name || he.calendar.noTitle;
};

export default function MeetingChip({ meeting, partners, onClick, compact, style }) {
  const cls = [
    'meeting-chip',
    compact ? 'compact' : '',
    isInternal(meeting) ? 'internal' : '',
    isCancelled(meeting) ? 'cancelled' : '',
    isHeld(meeting) ? 'held' : '',
  ].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      className={cls}
      style={{ ...chipStyle(meeting, partners), ...style }}
      onClick={() => onClick(meeting)}
      // The owner's name is not on the compact chip — there is no room — so the title
      // attribute carries it, together with the time, for anything the chip has to cut.
      title={`${meeting.start_time}–${meeting.end_time} · ${meetingLabel(meeting)} · ${meeting.owner_name}`}
    >
      <span className="chip-time">{meeting.start_time}</span>
      <span className="chip-label">{meetingLabel(meeting)}</span>
      {!compact && meeting.job_title && <span className="chip-job">{meeting.job_title}</span>}
      {isCancelled(meeting) && <span className="chip-flag">{he.calendar.cancelled}</span>}
      {!isCancelled(meeting) && isHeld(meeting) && <span className="chip-flag">{he.calendar.held}</span>}
    </button>
  );
}
